import angular from 'angular';

const filtersModule = angular.module('ngeoAngularFilters');

filtersModule.filter('formatData', function () {
    return function (input) {
        if (input === null || input === undefined) {
            return '';
        }

        if (typeof input === 'boolean') {
            return input ? 'Ja' : 'Nein';
        }

        // Dates
        if (typeof input === 'string') {
            const isoUtcRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/;
            if (isoUtcRegex.test(input)) {
                const date = new Date(input);
                const days = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${days}.${month}.${year}`;
            }
        }

        return input;
    };
});
